module.exports = __webpack_public_path__ + "img/collection-diamondJewelryColliers@2x.801aa78.webp";